import { useTranslation } from 'react-i18next';
import { Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import { MenuRecipeSummary } from '../types';
import DietaryAttributeChips from '../../RecipeV2/components/DietaryAttributeChips';

interface AllergensAndDietaryTabProps {
  recipeSummaries: MenuRecipeSummary[];
}

/** Allergen/dietary attributes per dish, aggregated live from RecipeV2 (via
 * menusClient.getRecipeSummariesForMenu) rather than duplicated onto the Menu record. */
const AllergensAndDietaryTab = ({ recipeSummaries }: AllergensAndDietaryTabProps) => {
  const { t } = useTranslation('menus');

  if (recipeSummaries.length === 0) {
    return (
      <Paper variant="outlined"
        sx={{ p: 4, textAlign: 'center' }}>
        <Typography color="text.secondary">
          {t('noDishes', 'This menu has no dishes to cost yet.')}
        </Typography>
      </Paper>
    );
  }

  return (
    <TableContainer>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>{t('dish', 'Dish')}</TableCell>
            <TableCell>{t('allergensAndDietary', 'Allergens & Dietary')}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {recipeSummaries.map((summary) => (
            <TableRow key={summary.recipeId}>
              <TableCell>{summary.recipeName}</TableCell>
              <TableCell>
                <Stack direction="row"
                  spacing={1}
                  flexWrap="wrap">
                  <DietaryAttributeChips attributes={summary.dietaryAttributes} />
                </Stack>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default AllergensAndDietaryTab;
